import { render, staticRenderFns } from "./addNoteModal.vue?vue&type=template&id=040f4aae&scoped=true"
import script from "./addNoteModal.vue?vue&type=script&lang=js"
export * from "./addNoteModal.vue?vue&type=script&lang=js"
import style0 from "./addNoteModal.vue?vue&type=style&index=0&id=040f4aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f4aae",
  null
  
)

export default component.exports